export const textfieldInlineButton = {
  padding: '0',
  paddingRight: '12px'
};

export const center = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};
